module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1210.6be6b2d3.png";